module.exports = __webpack_public_path__ + "img/packshot.29e05d29.png";